import { getMonth, getYear } from "date-fns";

export type dateToQuarterProps = {
  quarter: number;
  year: number;
};

/**
 * Transforms the date in Quarters
 * @param date - The date (10-03-2025)
 * @returns The date in Quarters {quarter: 1, year: 2025}
 */
export const dateToQuarter = (date?: string): dateToQuarterProps | undefined => {
  if (date) {
    const month = getMonth(date) + 1;
    const year = getYear(date);
    const quarter = Math.ceil(month / 3);

    return {
      quarter: quarter,
      year: year,
    };
  }

  return undefined;
};
